import { BehaviorParameters } from 'rangeConfig/@types';
import { NightLightsSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';

const deleteLights = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) return;

  if (
    coreApi.entities.isProductType(selectedEntity, ProductType.PAX_INNER_LIGHT) ||
    coreApi.entities.isProductType(selectedEntity, ProductType.PAX_INNER_LIGHT_OVERSIDAN)
  ) {
    coreApi.entities.delete(selectedEntity);
  } else {
    const frame = coreApi.entities.getParent(selectedEntity);

    if (frame) {
      const lights = coreApi.entities.getChildrenWithProductType(
        frame,
        ProductType.PAX_OUTER_LIGHT
      );
      coreApi.entities.deleteMultiple(lights);
    }
  }

  const currentLightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);

  if (currentLightsInScene.length === 0) {
    coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disable();
    coreApi.emit.onEnableNightMode(false);
  }
};

export default deleteLights;
